// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"f608eb56","227":"53547855","238":"844bb768","412":"0bfea715","496":"859c67f7","526":"84cc5bcb","582":"64962b86","678":"e4526a6a","856":"59ecd243"}[chunkId] + ".chunk.js";
};